import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

const GENDER = [
  { name: 'Male', value: 0 },
  { name: 'Female', value: 1 },
  { name: 'Other', value: 2 },
];

const Gender = ({
  name = 'gender',
  label = 'Gender',
  placeholder = 'Select Gender',
  rules,
  disabled,
  required,
  className,
  ...props
}: FormItemProps) => {
  const { t } = useTranslation('Vindoc');

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, required, className, ...props }}
      {...(rules && { rules })}
    >
      {GENDER?.map((st) => (
        <Select.Option key={st.value} value={st.value}>
          {t(st.name)}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Gender;
